import types from '../types';

/**
 * @param {types.Filter[]} filters
 * @param  {types.AdvancedFilter[]} advancedFilters
 * @returns {?number}
 */
const getActiveAdvancedFilterIndex = (filters, advancedFilters) => {
    if (
        !filters ||
        !Array.isArray(filters) ||
        !advancedFilters ||
        !Array.isArray(advancedFilters)
    ) {
        return null;
    }
    const selectedFilters = filters.find(
        filter => filter.radio && filter.radio.checked
    );

    const advancedFilterId = selectedFilters
        ? selectedFilters.advancedFiltersId
        : null;

    const index = advancedFilters.findIndex(
        filter => filter.id === advancedFilterId
    );

    if (index === -1) {
        return null;
    }

    return index;
};

export default getActiveAdvancedFilterIndex;
